import React from 'react';
import { Box, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Divider from '@/components/Divider';
import LeadInHeroSummary from '@/components/LeadInHeroSummary';
import Link from '@/components/Link';
import PropertyTitle from '@/components/PropertyTitle';
import PropertyContent from '@/propTypes/PropertyContent';
import SearchQuery from '@/propTypes/SearchQuery';
import ImageGallery from '@/shared/components/ImageGallery';
import sortImages from '@/utils/sortImages';

const FeaturedProperty = ({
  propertyContent,
  nights,
  price,
  content,
  searchQuery,
}) => {
  const href = {
    pathname: `/${propertyContent.destination.name}/properties/${propertyContent.id}/package`,
    query: searchQuery,
  };

  return (
    <Flex
      flexDirection="column"
      height="700px"
      justifyContent="space-between"
      borderRadius="default"
      backgroundColor="white"
    >
      <Box>
        <ImageGallery
          images={sortImages(propertyContent.images, propertyContent.mainImage)}
          height="160px"
          altText={propertyContent.name}
        />
        <Box px="5" py="3" flex="1">
          <PropertyTitle
            size="sm"
            propertyContent={propertyContent}
            href={href}
          />
          {content}
        </Box>
      </Box>
      <Box px="5" pb="5">
        <Divider mt="2" mb="6" />
        <LeadInHeroSummary nights={nights} />
        {price}
        <Box mt={4}>
          <Link.Button href={href} variant="primary" block outline>
            {price ? 'VIEW DEAL' : 'FIND OUT MORE'}
          </Link.Button>
        </Box>
      </Box>
    </Flex>
  );
};

FeaturedProperty.propTypes = {
  propertyContent: PropTypes.shape(PropertyContent).isRequired,
  nights: PropTypes.number,
  price: PropTypes.node,
  content: PropTypes.node,
  searchQuery: PropTypes.shape(SearchQuery),
};

export default FeaturedProperty;
